import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { Card } from '../../../../models/loyalty-card.model';
import { ApiMethods, PermissionConfiguration } from '../../../../models/permission.model';
import { CustomerCardService } from '../../../../services/customer/customer-card.service';
import { LoyaltyCardBatchService } from '../../../../services/loyalty/loyalty-card-batch.service';
import { LoyaltyCardDefinitionService } from '../../../../services/loyalty/loyalty-card-definition.service';
import { LoyaltyCardService } from '../../../../services/loyalty/loyalty-card.service';
import { LoyaltyChannelService } from '../../../../services/loyalty/loyalty-channel.service';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
import { LoyaltyReasonService } from '../../../../services/loyalty/reason.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';
import { PermsService } from '../../../../services/utils/perms.service';

@Component({
  selector: 'app-form-card',
  templateUrl: './form-card.component.html',
  styleUrls: ['./form-card.component.css']
})
export class FormCardComponent implements OnInit {

  @Input() cardId: string;
  @Input() readonly: boolean;

  form: FormGroup;
  editMode: boolean;
  channels: Array<{ value: string, label: string }> = sessionStorage.getItem('cardChannels') ? JSON.parse(sessionStorage.getItem('cardChannels')) : [{ value: null, label: '' }];
  stores: Array<{ value: number, label: string }> = sessionStorage.getItem('cardStores') ? JSON.parse(sessionStorage.getItem('cardStores')) : [{ value: null, label: '' }];
  reasons: Array<{ value: number, label: string }> = sessionStorage.getItem('cardReasons') ? JSON.parse(sessionStorage.getItem('cardReasons')) : [{ value: null, label: '' }];
  params: Array<{ value: number, label: string }> = sessionStorage.getItem('cardTypes') ? JSON.parse(sessionStorage.getItem('cardTypes')) : [{ value: null, label: '' }];
  cardBatchs: Array<{ value: number, label: string }> = sessionStorage.getItem('cardBatches') ? JSON.parse(sessionStorage.getItem('cardBatches')) : [{ value: -1, label: '' }];
  cardDefinitions: Array<{ value: number, label: string }> = sessionStorage.getItem('cardDefinitions') ? JSON.parse(sessionStorage.getItem('cardDefinitions')) : [{ value: null, label: '' }];

  isFromCustomerDetail: boolean;

  // Abilita il form di gestione di Blacklist
  public cardEditBlacklistPermission: boolean;
  public cardEditBlacklistPermissionCheck: PermissionConfiguration;

  fields: any;
  public invalidSubmit: boolean;

  defaultStartDate: Date;
  defaultEndDate: Date;
  dateFieldsDisabled = false;

  pdfBaseUrl: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private cardService: LoyaltyCardService,
    private customerCardService: CustomerCardService,
    private channelService: LoyaltyChannelService,
    private storeService: StoreCommonService,
    private paramService: LoyaltyParamsService,
    private cardBatchService: LoyaltyCardBatchService,
    private cardDefinitionService: LoyaltyCardDefinitionService,
    private permSrv: PermsService
  ) {

    this.cardEditBlacklistPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'card-edit-blacklist',
      method: ApiMethods.GET
    };

  }

  ngOnInit() {

    this.paramService.getPdfBaseUrl().subscribe(res => this.pdfBaseUrl = res.param_code);

    this.editMode = false;

    this.cardId = this.activatedRoute.snapshot.params['cardId'];
    this.readonly = this.activatedRoute.snapshot.data.readonly;
    this.editMode = this.cardId !== undefined;
    this.isFromCustomerDetail = !!this.activatedRoute.snapshot.params['customerId'];

    if (this.editMode) {
      this.dateFieldsDisabled = true;
    }

    this.cardEditBlacklistPermission = false;

    this.cardService.getFields().subscribe(res => {
      this.fields = res;
    });

    let card: Observable<any>;
    let Channel: Observable<any>;
    let Store: Observable<any>;
    let Param: Observable<any>;
    let cardBatch: Observable<any>;
    let cardDefinition: Observable<any>;
    let ReasonBlackList: Observable<any>;

    if (!this.editMode) {
      card = Observable.of(new Card());
    } else {
      card = this.cardService.get(this.cardId);
    }

    if (!sessionStorage.getItem('cardChannels')) {
      Channel = this.channelService.list();
    }

    if (!sessionStorage.getItem('cardStores')) {
      Store = this.storeService.getList();
    }

    if (!sessionStorage.getItem('cardTypes')) {
      Param = this.paramService.list(null, null, [{ key: 'param_group', value: 'CardType' }]);
    }

    if (!sessionStorage.getItem('cardBatches')) {
      cardBatch = this.cardBatchService.list();
    }

    if (!sessionStorage.getItem('cardDefinitions')) {
      cardDefinition = this.cardDefinitionService.list();
    }

    if (!sessionStorage.getItem('cardReasons')) {
      ReasonBlackList = this.cardService.getReasonList({ paramKey: LoyaltyCardService.REASON_LIST_BLACKLIST_TYPE, flg_state: 0 });
    }

    let obCardEditBlacklistPermissionCheck: Observable<any>;
    obCardEditBlacklistPermissionCheck = this.permSrv.check(this.cardEditBlacklistPermissionCheck);

    obCardEditBlacklistPermissionCheck.subscribe(resCardEditBlacklistPermissionCheck => this.cardEditBlacklistPermission = resCardEditBlacklistPermissionCheck);

    if (Channel && Store && Param && cardBatch && cardDefinition && ReasonBlackList) {
      Observable.zip(Channel, ReasonBlackList, Store, Param, cardBatch, cardDefinition)
        .subscribe(([resChannel, resReason, resStore, resParam, resCardBatch, resCardDefinition]) => {

          if (!sessionStorage.getItem('cardChannels')) {
            for (const channel of resChannel.data) {
              this.channels.push({
                label: channel.channelDescription,
                value: channel.id
              });
            }
            sessionStorage.setItem('cardChannels', JSON.stringify(this.channels));
          }

          if (!sessionStorage.getItem('cardStores')) {
            for (const store of resStore) {
              this.stores.push({
                label: `${store.host_code} - ${store.description}`,
                value: store.id
              });
            }
            sessionStorage.setItem('cardStores', JSON.stringify(this.stores));
          }

          if (!sessionStorage.getItem('cardReasons')) {
            for (const paramReason of resReason.data) {
              this.reasons.push({
                label: paramReason.description,
                value: paramReason.id
              });
            }
            sessionStorage.setItem('cardReasons', JSON.stringify(this.reasons));
          }

          if (!sessionStorage.getItem('cardTypes')) {
            for (const param of resParam.data) {
              this.params.push({
                label: param.description,
                value: param.id
              });
            }
            sessionStorage.setItem('cardTypes', JSON.stringify(this.params));
          }

          if (!sessionStorage.getItem('cardBatches')) {
            for (const batch of resCardBatch.data) {
              this.cardBatchs.push({
                label: batch.id.toString() + ' - ' + ' min ' + batch.num_min + ' - max ' + batch.num_max,
                value: batch.id
              });
            }
            sessionStorage.setItem('cardBatches', JSON.stringify(this.cardBatchs));
          }

          if (!sessionStorage.getItem('cardDefinitions')) {
            for (const definition of resCardDefinition.data) {
              this.cardDefinitions.push({
                label: definition.description,
                value: definition.id
              });
            }
            sessionStorage.setItem('cardDefinitions', JSON.stringify(this.cardDefinitions));
          }

        },
          error => console.error(error),
          () => {
            card.subscribe(res => {

              if (res.date_start) {
                this.defaultStartDate = new Date(res.date_start);
                this.dateFieldsDisabled = true;
              }

              if (res.date_end) {
                this.defaultEndDate = new Date(res.date_end);
              }

              this.form = this.fb.group({
                channel_id: [{ value: res.channel_id || '', disabled: this.editMode || this.readonly }],
                card_no: [{ value: res.card_no || '', disabled: this.editMode || this.readonly }],
                card_batch_id: [{ value: res.card_batch_id || -1, disabled: this.editMode || this.readonly }],
                card_type_pid: [{ value: res.card_type_pid || '', disabled: this.editMode || this.readonly }],
                card_def_id: [{ value: res.card_def_id || '', disabled: this.editMode || this.readonly }],
                flg_blk_lst: { value: res.flg_blk_lst === '1', disabled: this.readonly },
                store_id: { value: res.store_id || '', disabled: this.editMode || this.readonly },
                date_start: { value: res.date_start ? moment(res.date_start).format('DD/MM/YYYY').toString() : '', disabled: this.editMode || this.readonly },
                date_end: { value: res.date_end ? moment(res.date_end).format('DD/MM/YYYY').toString() : '', disabled: this.editMode || this.readonly },
                reason_id: { value: res.reason_id || '', disabled: this.readonly },
                date_blk_lst: { value: res.date_blk_lst ? moment(res.date_blk_lst).format('DD/MM/YYYY') : '', disabled: this.readonly },
                time_blk_lst: { value: res.time_blk_lst ? moment(res.time_blk_lst).format('h:mm') : '', disabled: this.readonly },
                pdf_link: [{ value: res.pdf_link || '', disabled: this.readonly }]
              });
            })
          }
        );
    } else {
      card.subscribe(res => {

        if (res.date_start) {
          this.defaultStartDate = new Date(res.date_start);
        }

        if (res.date_end) {
          this.defaultEndDate = new Date(res.date_end);
        }

        this.form = this.fb.group({
          channel_id: [{ value: res.channel_id || '', disabled: this.editMode || this.readonly }],
          card_no: [{ value: res.card_no || '', disabled: this.editMode || this.readonly }],
          card_batch_id: [{ value: res.card_batch_id || -1, disabled: this.editMode || this.readonly }],
          card_type_pid: [{ value: res.card_type_pid || '', disabled: this.editMode || this.readonly }],
          card_def_id: [{ value: res.card_def_id || '', disabled: this.editMode || this.readonly }],
          flg_blk_lst: { value: res.flg_blk_lst === '1', disabled: this.readonly },
          store_id: { value: res.store_id || '', disabled: this.editMode || this.readonly },
          date_start: { value: res.date_start ? moment(res.date_start).format('DD/MM/YYYY').toString() : '', disabled: this.editMode || this.readonly },
          date_end: { value: res.date_end ? moment(res.date_end).format('DD/MM/YYYY').toString() : '', disabled: this.editMode || this.readonly },
          reason_id: { value: res.reason_id || '', disabled: this.readonly },
          date_blk_lst: { value: res.date_blk_lst ? moment(res.date_blk_lst).format('DD/MM/YYYY') : '', disabled: this.readonly },
          time_blk_lst: { value: res.time_blk_lst ? moment(res.time_blk_lst).format('h:mm') : '', disabled: this.readonly },
          pdf_link: [{ value: res.pdf_link || '', disabled: this.readonly }]
        });
      })
    }

    this.blacklistChange();
  }

  blacklistChange() {
    if (this.form !== undefined) {
      this.form.get('date_blk_lst').setValue('');
      this.form.get('time_blk_lst').setValue('');
      this.form.get('reason_id').setValue(null);
    }
  }

  /**
   * Se form in edit mode, richiama il metodo 'update' da 'loyaltyCardService' per aggiornare i dati di una carta esistente,
   * altrimenti il metodo 'create' per creare una nuova carta, ed il metodo 'createCardLink' che riceve, come argomento,
   * il card.id della nuova carta.
  */
  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    const card = new Card();
    card.channel_id = this.form.get('channel_id').value;
    card.card_no = this.form.get('card_no').value;
    card.card_batch_id = this.form.get('card_batch_id').value === -1 ? null : this.form.get('card_batch_id').value;
    card.reason_id = this.form.get('reason_id').value ? this.form.get('reason_id').value : null;
    card.flg_blk_lst = (this.form.get('flg_blk_lst').value) ? 1 : 0;
    card.store_id = this.form.get('store_id').value ? this.form.get('store_id').value : null;
    card.card_type_pid = this.form.get('card_type_pid').value;
    card.card_def_id = this.form.get('card_def_id').value;
    card.pdf_link = this.form.get('pdf_link').value;

    if (this.form.get('date_start').value !== '') {
      card.date_start = moment(this.form.get('date_start').value, 'DD/MM/YYYY').format('MMM D, YYYY h:mm:ss A');
    }

    if (this.form.get('date_end').value !== '') {
      card.date_end = moment(this.form.get('date_end').value, 'DD/MM/YYYY').format('MMM D, YYYY h:mm:ss A');
    }

    if (card.flg_blk_lst === 1) {
      if (this.form.get('date_blk_lst').value !== '') {
        card.date_blk_lst = moment(this.form.get('date_blk_lst').value, 'DD/MM/YYYY').format('MMM D, YYYY h:mm:ss A');
      }

      // T2697: nascondiamo il campo "orario" in quanto questo avra come orario di default "ADESSO"
      if (this.form.get('time_blk_lst').value !== '') {
        card.time_blk_lst = moment(this.form.get('time_blk_lst').value, 'h:mm').format('MMM D, YYYY h:mm:ss A');
      }
    }

    if (!this.editMode) {
      this.cardService.create(card).subscribe(res => {
        this.customerCardService.createCardLink(res.id).subscribe(() => {
          this.router.navigate(['/loyalty/card']);
        });
      });
    } else {
      card.id = this.cardId;
      this.cardService.update(card).subscribe(() => {
        this.router.navigate(['/loyalty/card']);
      });
    }
  }

  canEdit(): boolean {
    // per il moemnto senza permesso.
    return this.readonly;
  }

  goBack() {
    const customerId = this.activatedRoute.snapshot.params['customerId'];
    const vCustomerId = this.activatedRoute.snapshot.params['vCustomerId'];
    const previousTab = this.activatedRoute.snapshot.params['previousTab'];

    if (customerId && vCustomerId && previousTab) {
      this.router.navigate([`customers-details/${customerId}/${vCustomerId}`, { previousTab: previousTab }]);
    } else {
      this.router.navigate(['/loyalty/card']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card/form-card/form-card.component.ts